module.exports = __webpack_public_path__ + "static/media/medic-r450.8aa88df9.png";